// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__cDdrM","productName":"Table_productName__2uFnU"};